/**
 * 所属公司过滤单选
 *    默认选择全部
 *    接收onChange事件 以数组的格式返回所选公司的全部数据
 */

import React, { useState, useEffect, useRef } from 'react'
import { Tag, Icon, message } from 'antd'
import api from '@/api'
import './style.scss'
import { useDispatch } from 'react-redux'
import { setCompanyList } from '@/global/reducer/companyList'

const { CheckableTag } = Tag

const CorpFilter = props => {
  const { clickFlag = true } = props
  const [list, setList] = useState([])
  const [checkedAll, setCheckedAll] = useState(true)
  const [showAll, setShowAll] = useState(false)
  const [showAllBtn, setShowAllBtn] = useState(false)

  const listRef = useRef(null)
  const dispatch = useDispatch()

  useEffect(() => {
    let notHeadOffice = props.notHeadOffice!=undefined ? props.notHeadOffice : 0
    api.getCorpFilterList({ limit: global.paramsLimit ,'notHeadOffice': notHeadOffice}).then(data => {
      const list = data.map(item => ({ ...item}))
      setList(list)
      dispatch(setCompanyList(list))
    })
  }, [])

  useEffect(() => {
    if (listRef.current.scrollHeight > 25) {
      setShowAllBtn(true)
    }
  })

  useEffect(() => {
    window.addEventListener('resize', onSetShowAllBtn, false)
    return () => {
      window.removeEventListener('resize', onSetShowAllBtn, false)
    }
  })

  const onSetShowAllBtn = () => {
    if (listRef.current.scrollHeight > 25) {
      setShowAllBtn(true)
    } else {
      setShowAllBtn(false)
    }
  }

  const onChange = (checked, id) => {
    if (!clickFlag) {
      return message.info('请不要频繁操作！')
    }
    // 单选[]
    const items = list.map(item => {
      if (item.id === id) {
        return { ...item, checked }
      }
      return { ...item, checked: false }
    })

    const checkedList = items.filter(item => item.checked)
    setList(items)
    if (checkedList.length === 0) {
      setCheckedAll(true)
    } else {
      setCheckedAll(false)
    }
    props.onChange(checkedList)
  }

  const onChangeAll = checked => {
    if (checked) {
      setList(list.map(item => ({ ...item, checked: false })))
      setCheckedAll(true)
      props.onChange([])
    }
  }

  const labelText = props.label || '所属公司'

  return (
    <div className="corp-filter-wrap">
      <label htmlFor="">{labelText}：</label>
      <div className={`corp-filter-list${showAll?' show-all':''}`} ref={listRef}>
        <CheckableTag checked={checkedAll} onChange={checked => onChangeAll(checked)}>全部</CheckableTag>
        {list.map(d => <CheckableTag key={d.id} checked={d.checked} onChange={checked => onChange(checked, d.id)}>{d.name}</CheckableTag>)}
      </div>
      {showAllBtn ? <div className="corp-filter-control-wrap">
        {showAll
          ? <span className="corp-filter-control" onClick={() => setShowAll(false)}>收起<Icon type="up" /></span>
          : <span className="corp-filter-control" onClick={() => setShowAll(true)}>展开<Icon type="down" /></span>
        }
      </div> : null}
    </div>
  )
}

export default CorpFilter